import {
  post
} from "@/api/requrestHttp.js";
export const tabdata = {
  data () {
    return {
      tableData: [],
      pageConfig: {
        pageSize: 10,
        total: 0,
        pageNo: 1
      },
      tableDataUrl: '',
      searchlist: {},
      shortName: [],

    }
  },
  components: {},
  methods: {
    //分页
    handleCurrentChange (val) {
      this.pageConfig.pageNo = val;
      this.getPageDatas();
    },
    //条件查询
    searchlistdata () {
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //条件查询重置
    searchlistReset () {
      this.searchlist = {}
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //每页展示条数
    handleSizeChange (val) {
      this.pageConfig.pageSize = val
      this.pageConfig.pageNo = 1
      this.getPageDatas();
    },
    //获取列表数据
    getPageDatas () {  
      post('/admin/serviceItems/info/listServiceItems', { 
        pageSize:this.pageConfig.pageSize,
        pageNo:this.pageConfig.pageNo,
        ...this.searchlist
      }).then((res) => { 
        res.content.list.forEach(item => {
          item.signUpTimes = item.signUpTimes.substring(0, 16);
          item.startActivityTime = item.startActivityTime.substring(0, 16);
          item.endActivityTime = item.endActivityTime.substring(0, 16)
        })
        console.log(2323,res.content.list);
        this.tableData = res.content.list;
        this.pageConfig.total = res.content.count; 
      }).catch(() => {
        // this.$message.error("获取信息失败");
      })
    },
    initTableDataUrl (url) {
      this.tableDataUrl = url;
      this.getPageDatas()
    }
  }
}